import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';
import nyyrdiHelper from './../nyyrdiHelper';

class SkyringView extends Component {
	render() {
		let dataItem = this.props.data;

		let hasUpvote = false;
		let hasDownvote = false;

		if (localStorage) {
			if (localStorage.getItem('upvote-'+dataItem.id)) {
				hasUpvote = true;
			}
			if (localStorage.getItem('downvote-'+dataItem.id)) {
				hasDownvote = true;
			}
		}

		return (
			<div className="metadata-container">
				<span className="skyring-index">{this.props.index+1}</span>

				<p className="skyring">
					{dataItem.merking.split('\n').map(function(item, index) {
						return <React.Fragment>
							{item}
							{
								index < dataItem.merking.split('\n').length-1 &&
								<br/>
							}
						</React.Fragment>
					})}
					{
							dataItem.uppruni_erl_ord && dataItem.merking &&
							<React.Fragment><br/><br/></React.Fragment>

					}
					{
						dataItem.uppruni_erl_ord &&
						<span>
							<strong>{nyyrdiHelper.capitalizeFirstLetter(nyyrdiHelper.tungumal[dataItem.uppruni_erl_lang] ? nyyrdiHelper.tungumal[dataItem.uppruni_erl_lang].toLowerCase() :  'óþekkt')}</strong>: <em>{dataItem.uppruni_erl_ord}</em>
						</span>
					}
				</p>

				<div className="voting-buttons">
					<button className={'upvote'} 
						disabled={hasUpvote} 
						onClick={function() {if (this.props.onUpvote) {this.props.onUpvote(dataItem.id)}}.bind(this)}>
							{dataItem.upvotes}
					</button>
					<button className={'downvote'} 
						disabled={hasDownvote} 
						onClick={function() {if (this.props.onDownvote) {this.props.onDownvote(dataItem.id)}}.bind(this)}>
							{dataItem.downvotes}
					</button>
				</div>

				<div className="clearfix" />

				{
					dataItem.daemi && dataItem.daemi.length > 0 &&
					<React.Fragment>

						<div className="examples-list">
							{
								dataItem.daemi.map(function(item, index) {
									return <div key={index} className="example">
										<blockquote>{item.daemi}</blockquote>
										<p className="source">
											{
												item.url &&
												<a href={item.url}>{item.heimild}</a>
											}
											{
												!item.url &&
												item.heimild
											}
											{
												item.dagsetning &&
												(item.heimild ? ', ' : '')+nyyrdiHelper.formatDate(item.dagsetning, true)
											}
										</p>
									</div>;
								})
							}
						</div>

					</React.Fragment>
				}
				{
					(dataItem.sendandi_nafn || dataItem.inserttime) &&
					<p>
						{
							dataItem.sendandi_nafn &&
							<React.Fragment><strong>Sendandi: </strong> {dataItem.sendandi_nafn+(dataItem.sendandi_postnumer || dataItem.sendandi_stadur ? ', '+(dataItem.sendandi_postnumer ? dataItem.sendandi_postnumer+' ' : '')+(dataItem.sendandi_stadur ? dataItem.sendandi_stadur : '') : '')}</React.Fragment>
						}
						{
							dataItem.sendandi_nafn && dataItem.inserttime &&
							<React.Fragment><br/><small>Sent þann {nyyrdiHelper.formatDate(dataItem.inserttime, true)}</small></React.Fragment>
						}
					</p>
				}
				{
					dataItem.tengd_nyyrdi && dataItem.tengd_nyyrdi.length > 0 &&
					<React.Fragment>
						<h5><span>Tengd nýyrði</span></h5>
						<div className="text-center mb-4">
							{
								dataItem.tengd_nyyrdi.map(function(item) {
									return <Link className="btn btn-secondary btn-small" to={'/nyyrdi/'+item.id}>{item.ord}</Link>
								})
							}
						</div>
					</React.Fragment>
				}
				{
					dataItem.inserttime != dataItem.changetime &&
					<div className="word-footnote">
						<small>Síðast breytt: {nyyrdiHelper.formatDate(dataItem.changetime, true)}</small>
					</div>
				}

			</div>
		);
	}
}

export default SkyringView;



// WEBPACK FOOTER //
// ./src/components/SkyringView.js